export default {
  ADD(state, val) {
    state.activities.unshift(val);
  },
  UPDATE(state, val) {
    const i = state.activities.findIndex(i => i.id == val.id)
    state.activities[i].status = val.status
  },

  CLEAR(state, val) {
    const list = state.activities.filter(i => i.status == '2')
    state.activities = list
  }
}
